/*=========================================================================================
  File Name: moduleUserState.js
  Description: User Module State
  ----------------------------------------------------------------------------------------
==========================================================================================*/

export default {
  users: [],
  infoDB: {}
}
